const ButterList = [
    {
      image:
        "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette-detail/Recette_cosmetique/O472303_creme-satinante-corps-web.jpg",
      name: "Manteca corporal de almendras",
      description:
        "¿Ganas de disfrutar del placer de una manteca hidratante con propiedades relajantes?La Manteca Corporal Relajante de Almendra te encantará.Para el placer de un tratamiento corporal relajante, nuestra cadena de expertos, única dede 1959, ha seleccionado y asociado la manteca de Karité bio con el absoluto de extracto de Almendra.",
      price: 10.99,
      id: 4,
    },
    {
      image:
        "https://us.123rf.com/450wm/tanyalovus/tanyalovus1803/tanyalovus180300261/97402677-crema-cosm%C3%A9tica-de-aguacate-en-la-cara-de-madera-rosa-saludable-fresca-antiarrugas.jpg?ver=6",
      name: "Manteca corporal de aguacate",
      description:
        "Este producto combina aceite de aguacate puro con manteca de karité pura. El resultado es una manteca suave, con propiedades particularmente hidratantes. Es rica en vitamina A, B, G y E. Penetra profundamente en la piel, nutriéndola y dejándola suave y fresca.",
      price: 12.99,
      id: 1,
    },
    {
      image:
        "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette-detail/Recette_cosmetique/N021378_chantilly_kariteframboise_OPT40.jpg",
      name: "Manteca corporal de frambuesa",
      description:
        "Para el placer de un tratamiento corporal energizante, nuestra cadena de Expertos, única desde 1959, ha seleccionado y combinado la manteca de Karité Bio, el aceite esencial de la Hierbabuena y extracto de Frambuesa. La piel está hidratada y delicadamente perfumada.",
      price: 10.99,
      id: 7,
    },
    {
      image:
        "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette-detail/Recette_cosmetique/M101121_Baume-cremeux-karite-macadamia_web.jpg",
      name: "Manteca corporal de karité",
      price: 15.99,
      description:
        "Nuestra Manteca Corporal Nutritiva de Karité contiene manteca de karité Ghana de Comercio con Comunidades, producida a mano por una cooperativa de mujeres que lleva generaciones usando la manteca de karité para nutrir la piel seca. Esta icónica hidratante corporal tiene una nueva fórmula todavía más cremosa que mantiene la piel hidratada hasta 72 horas. Disfruta de su cálido aroma y su cremosa textura que se funde al contacto con la piel.",
      id: 8,
    },
  {
    image:
      "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette-detail/Recette_cosmetique/K39649_creme-zones-seches_nourissante-protectrice_huiles-olive-avocat.jpg",
    name: "Manteca corporal de oliva",
    description:
      "Disfruta de piel suave con la Manteca Corporal Nutritiva de Oliva, enriquecida con aceite de oliva orgánico de Comercio con Comunidades de Cilento, Italia. Las mujeres mediterráneas llevan siglos usando el aceite de oliva para hidratar la piel seca. Esta hidratante corporal mantiene la piel nutrida e hidratada hasta 72 horas y tiene una textura cremosa que se funde con tu piel.",
    price: 17.99,
    id: 6,
  },
  {
    image:
      "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette-detail/Recette_cosmetique/N281613_beurre.JPG",
    name: "Manteca corporal de coco",
    description:
      "Mima tu piel con una dosis extra de hidratación con esta manteca corporal nutritiva de coco. Sus propiedades nutritivas se prolongan 48 horas para que disfrutes de una piel suave durante más tiempo.",
    price: 14.99,
    id: 2,
  },
  {
    image:
      "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette/Recette_cosmetique/J42390_Beurre-cocooning-pain-epices-miel_web.jpg",
    name: "Manteca corporal de miel",
    description:
      "Esta rica manteca corporal, enriquecida en aceites naturales, ha sido concebida para calmar y proteger la piel sensible. Di adiós a la tirantez y el picor en tu piel con 48 horas de intensa hidratación.",
    price: 15.99,
    id: 3,
  },
  {
    image:
      "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette/Recette_cosmetique/K49718_creme-corps_euphorisante_anis-papaye.jpg",
    name: "Manteca corporal de piña",
    description:
      "Este tratamiento tan nutritivo e hidratante con su rica textura ofrece un cuidado completo para la piel seca y deshidratada del cuerpo. La manteca corporal de piña deja la piel muy suave y acondicionada. El extracto de pino enano siberiano aporta ácidos grasos esenciales, que son necesarios para una buena nutrición. El aceite de serbal siberiano proporciona una gran hidratación a la piel dejándola suave y cuidada.",
    price: 8.99,
    id: 5,
  },
  {
    image:
      "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette-detail/Recette_cosmetique/M091106_baume-soin_fleurs-gardenia-incas.jpg",
    name: "Manteca corporal de fleurs des îles",
    description:
      "Apuesta por la Manteca Corporal de Fleurs des îles para disfrutar de una hidratación sublime. Enriquecida con aceite de semillas de moringa recolectadas a mano, notarás la piel más suave y nutrida tras cada uso",
    price: 15.99,
    id: 9,
  },
  {
    image:
      "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette-detail/Recette_cosmetique/J35356_beurre-corporel_nourrissant_vanille-des-iles.jpg",
    name: "Manteca corporal de vainilla",
    description:
      "Para el placer de un tratamiento corporal sensual y de perfume cautivador, nuestra cadena de Expertos, única desde 1959, ha seleccionado y combinado la manteca de Karité Bio con el extracto de Vainilla Bourbon. La piel está hidratada y delicadamente perfumada.",
    price: 9.99,
    id: 10,
  },
  {
    image:
      "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette-detail/Recette_cosmetique/o232154_bodybutter-melonweb.jpg",
    name: "Manteca corporal de melón",
    description:
      "Nutre la piel con la Manteca Corporal de Melón y disfruta de su cremosa textura y deliciosa fragancia. La fórmula vegana de esta hidratante corporal hidrata la piel durante 72 horas y la deja suave y perfumada. Como el resto de la línea, la manteca corporal está enriquecida con puré de melones orgánicos de Comercio con Comunidades elaborado con melones descartados por la industria alimentaria por su forma o su tamaño.",
    price: 8.99,
    id: 11,
  },
  {
    image:
      "https://cdn.aroma-zone.com/cms/sites/default/files/imagecache/preset-recette/Recette_cosmetique/0101941_body-butter-mangue-repriseweb.jpg",
    name: "Manteca corporal de mango",
    description:
      "Para el placer de un tratamiento corporal energizante, nuestra cadena de Expertos, única desde 1959, ha seleccionado y combinado la manteca de Karité Bio, el aceite esencial del cilantro y extracto de Mango.",
    price: 10.99,
    id: 12,
  },
];

export default ButterList;
